export const streets = 'mapbox://styles/mapbox/streets-v9';
